module.exports = __webpack_public_path__ + "image/PRE_LOGO.png";